// Check if element with id 'scroll' exists
let chgpadd = document.getElementById('scroll');

// If 'scroll' doesn't exist, try 'scroll_mobile' or 'scroll_desktop'
if (!chgpadd) {
    chgpadd = document.getElementById('scroll_mobile') || document.getElementById('scroll_desktop');
}

// Iterate through elements with class 'isofirst'
const containerfirst = document.getElementsByClassName('isofirst');
for (let i = 0; i < containerfirst.length; i++) {
    const container = containerfirst[i];
    const items = container.querySelectorAll('.custom__item');
    const firstItem = items[0];

    // Set padding for the elements
    if (chgpadd) {
        chgpadd.style.paddingTop = '0';
    }
 

    // Insert the firstItem
    if (firstItem && container.parentNode) {
        container.parentNode.insertBefore(firstItem, container);
        const parentOfFirstItem = firstItem.parentNode;
        parentOfFirstItem.parentNode.insertBefore(firstItem, parentOfFirstItem);
        const parentOfFirstItemm = firstItem.parentNode;
        parentOfFirstItemm.parentNode.insertBefore(firstItem, parentOfFirstItemm);
    }
}

// Iterate through elements with class 'isolast'
const containerlast = document.getElementsByClassName('isolast');
for (let i = 0; i < containerlast.length; i++) {
    const container = containerlast[i];
    const items = container.querySelectorAll('.custom__item');
    const lastItem = items[items.length - 1];

    // Append the lastItem
    if (lastItem && container.parentNode) {
        container.parentNode.appendChild(lastItem);
        const parentOfFirstItem = lastItem.parentNode;
        parentOfFirstItem.parentNode.appendChild(lastItem);
        const parentOfFirstItemm = lastItem.parentNode;
        parentOfFirstItemm.parentNode.appendChild(lastItem);
    }
}

